((Accordion, $) => {

  const $dom = {};

  const cacheDom = () => {
    $dom.toggles = $('.js-accordion-toggle');
  };

  const bindUIActions = () => {
    $dom.toggles.on('click', (event) => $(event.currentTarget).toggleClass('active'));
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  Accordion.init = init;

})(window.Accordion = window.Accordion || {}, jQuery);  